<template>
  <b-card :title="$t('overview') + ' ' + $t('project') + ' #' + projectNumber" class="mb-4">
    <div class="info-grid">
      <div class="info-item">
        <span class="label">{{ $t('inCharge') }}</span>
        <span class="value">
          <span v-if="project.inCharge">
            {{ project.inCharge.firstname }} {{ project.inCharge.lastname }}
          </span>
          <span v-else>N/A</span>
        </span>
      </div>
      <div class="info-item">
        <span class="label">{{ $t('powerCompany') }}</span>
        <span class="value">
          <span v-if="project.powerCompany">{{ project.powerCompany.company }}</span>
          <span v-else>N/A</span>
        </span>
      </div>

      <div class="info-item">
        <span class="label">{{ $t('name') }}</span>
        <span class="value">{{ project.customer.lastname }}, {{ project.customer.firstname }}</span>
      </div>
      <div class="info-item">
        <span class="label">{{ $t('address') }}</span>
        <span class="value">
          <a :href="generateGoogleMapsLink(project.customer)" target="_blank">
            {{ project.customer.street }} {{ project.customer.streetNumber
            }}{{ project.customer.streetNumberSuffix }}<br />
            {{ project.customer.zip }} {{ project.customer.city }}
          </a>
        </span>
      </div>
    </div>
  </b-card>
</template>

<script>
import { generateGoogleMapsLink, startTeamsCall } from '@/helpers/integration';
export default {
  props: {
    project: { type: Object },
    projectNumber: null,
  },
  methods: {
    generateGoogleMapsLink,
  },
};
</script>

<style scoped lang="scss">
.info-grid {
  display: grid;
  gap: 0.75em;
  grid-template-columns: auto auto;
  align-items: start;
  justify-content: start;

  @media (min-width: 1500px) {
    grid-template-columns: repeat(2, auto auto);
    column-gap: 1.5em;
    row-gap: 0.75em;
  }

  .grid-divider {
    grid-column: 1 / -1;
    margin: 0;
    border: none;
    border-top: 1px solid #dee2e6;
  }
}

.info-item {
  display: contents;

  .label {
    font-weight: 600;
    color: #6c757d;
    white-space: nowrap;
    align-self: start;
    margin-right: 0.5em;
  }

  .value {
    align-self: start;
  }
}

.section-divider {
  margin: 1em 0 1em 0;
  border: none;
  border-top: 1px solid #dee2e6;
}

.communication-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
}

.communication-item {
  display: block;
}

.communication-label {
  color: #6c757d;
  display: inline;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

.communication-value {
  display: inline;
  margin-left: 0.25em;
}
</style>
